import { render, staticRenderFns } from "./NavbarSecondary.vue?vue&type=template&id=124207f6&"
import script from "./NavbarSecondary.vue?vue&type=script&lang=js&"
export * from "./NavbarSecondary.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSecondary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports